import {map} from 'lodash';
import {errorHandler} from 'utils/errorHandler';


const LOAD = 'server-sts/users/LOAD';
const LOAD_SUCCESS = 'server-sts/users/LOAD_SUCCESS';
const LOAD_FAIL = 'server-sts/users/LOAD_FAIL';
const EDIT_START = 'server-sts/users/EDIT_START';
const EDIT_STOP = 'server-sts/users/EDIT_STOP';
const SAVE = 'server-sts/users/SAVE';
const SAVE_SUCCESS = 'server-sts/users/SAVE_SUCCESS';
const SAVE_FAIL = 'server-sts/users/SAVE_FAIL';
const CREATE = 'server-sts/users/CREATE';
const CREATE_SUCCESS = 'server-sts/users/CREATE_SUCCESS';
const CREATE_FAIL = 'server-sts/users/CREATE_FAIL';
const DELETE = 'server-sts/users/DELETE';
const DELETE_SUCCESS = 'server-sts/users/DELETE_SUCCESS';
const DELETE_FAIL = 'server-sts/users/DELETE_FAIL';
const CLEAR = 'server-sts/users/CLEAR';

const SEND_CREDENTIALS = 'server-sts/users/SEND_CREDENTIALS';
const SEND_CREDENTIALS_SUCCESS = 'server-sts/users/SEND_CREDENTIALS_SUCCESS';
const SEND_CREDENTIALS_FAIL = 'server-sts/users/SEND_CREDENTIALS_FAIL';


const initialState = { 
  loaded: false,
  loading: false,
  created: false,
  userCreatedError:false,
  editing: {},
  saveError: false,
  saveSuccess:false,
  loadingSendCredentials:false,
  sendCredentialsSuccess:false,
  sendCredentialsError:false,
  is_editing:false,
  data:[]
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD:
      return {
        ...state,
        loading: true
      };
    case LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.result,
        error: null
      };
    case LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error:errorHandler(action.error.code)
      };
    case EDIT_START:
      return {
        ...state,
        editing: {
          ...state.editing,
          [action.id]: true
        },
        saveError: false,
        saveSuccess: false,
        is_editing:true,
      };
    case EDIT_STOP:
      return {
        ...state,
        editing: {
          ...state.editing,
          [action.id]: false
        },
        saveSuccess: false,
        saveError: false,
        is_editing:false
      };


    case DELETE:
      return state;

    case DELETE_SUCCESS:
      var users = action.result.users;
      return {
      	...state,
        data: users,
      };

    case DELETE_FAIL:
      return {
        ...state,
        error:errorHandler(action.error.code)
    	};

    case CREATE:
      return {
    		...state, 
    		loading:true,
    		
    	};

    case CREATE_SUCCESS:
    	return {
				...state,
				created:true,
				loading:false,
				userCreatedError:false,
				data:action.result.users,
				loading:false
			};

    case CREATE_FAIL:
    	return {
				...state,
				created:false,
				loading:false,
				userCreatedError:errorHandler(action.error.code),
				error:errorHandler(action.error.code)
			};

    case SAVE:
      return {
    		...state,
    		loading:true,
    	}

    case SAVE_SUCCESS:
      var users = action.result.users;
      return {
        //...state,
        data: users,
        editing: {
          ...state.editing,
          [action.result.id]: true
        },
        saveError: false,
        saveSuccess: true,
        loaded:false,
        loading:false,
      };
    case SAVE_FAIL:
      return {
        ...state,
        saveError: errorHandler(action.error.code),
        saveSuccess: false,
        loading:false,
        error:errorHandler(action.error.code)
      }

    case CLEAR:
    	return {
	      ...state,
	      saveError: false,
	      saveSuccess: false,
	      userCreatedError:false,
	      loaded:false,
	      created:false
	    }
    	
    	
    case SEND_CREDENTIALS:
      return {
    		...state,
    		loadingSendCredentials:true
    	};

    case SEND_CREDENTIALS_SUCCESS:
    	return {
				...state,
				loadingSendCredentials:false,
				sendCredentialsSuccess:true,
			  sendCredentialsError:false
			};

    case SEND_CREDENTIALS_FAIL:
    	return {
				...state,
				loadingSendCredentials:false,
				sendCredentialsSuccess:false,
			  sendCredentialsError:true,
			  error:errorHandler(action.error.code)
			};


    default:
      return state;
  }
}

export function isLoaded(globalState) {
  return globalState.users.loaded;
}

export function createUser(values, params) {
	
	
	if( values.user.sites != null ) {
	
  	values.user.sites = values.user.sites.map((s)=>{
  	  return s.value; 
  	})
  	
  }

	 
	
  return {
    types: [CREATE, CREATE_SUCCESS, CREATE_FAIL],
    promise: (client) => client.post('/user/create', {
      data: {
      	values,
      	params
      }
    })
  };
}

export function load(params) {
  return {
    promise: (client) => client.post('/user/load', {data:{params}}),
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL]
  };
}
//Pas besoin de params
export function save(values, params, fields, user_emails, pristine_sites, pristine_groups) {
  if( fields.user.sites.dirty ) {
    values.user.sites = values.user.sites.map( (s)=>{
      
       if( s instanceof Object && s.constructor === Object) {
         return s.value
       } else {
         return s  
       }
     })
  }
     
  
  return {
    types: [SAVE, SAVE_SUCCESS, SAVE_FAIL], 
    promise: (user) => user.post('/user/update', {
      data: {values, params, fields, user_emails, pristine_sites, pristine_groups} 
    })
  };
}

export function deleteUser(id, params) {
  return {
    types: [DELETE, DELETE_SUCCESS, DELETE_FAIL],
    promise: (user) => user.post('/user/deleteUser', {
      data: {id, params}
    })
  };
}

export function sendCredentials(userData, params) {
  return {
    types: [SEND_CREDENTIALS, SEND_CREDENTIALS_SUCCESS, SEND_CREDENTIALS_FAIL],
    promise: (user) => user.post('/user/sendCredentials', {
      data: {values:userData, params}
    })
  };
}


export function editStart(id) {
  return { type: EDIT_START, id };
}

export function editStop(id) {
  return { type: EDIT_STOP, id };
}

export function clear() {
  return { type: CLEAR };
}
